// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_content__9juYu {
    margin: 0 0;
    display: flex;
    flex-direction: column;
    flex: 1 1;
}

.styles_header__Q0alu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}

.styles_header__Q0alu h3 {
    margin: auto 0;
}

@media (min-height: 1080px) {
    .styles_content__9juYu {
        min-height: 750px;
    }
}

.styles_footer__Wv3M1 {
    text-align: center;
    border-top: 1px solid var(--light-grey);
    padding-top: 35px;
}

.styles_item__VyTt4 {
    display: flex;
    grid-gap: 12px;
    padding-bottom: 16px;
    position: relative;
}

.styles_item__VyTt4.styles_horizontal__\\+scOI {
    flex: 1 1;
    max-width: 100%;
    min-height: 80px;
    justify-content: center;
    padding: 0 14px;
}

.styles_item__VyTt4:not(.styles_horizontal__\\+scOI) {
    flex-direction: column;
    align-items: center;
}

.styles_item__VyTt4 h6 {
    font-weight: 100;
    text-transform: none;
    font-size: 14px;
    max-width: 100px;
    position: absolute;
}

.styles_item__VyTt4.styles_horizontal__\\+scOI h6 {
    left: calc(50% + calc(var(--item-size, 70px)) / 2 + 10px);
}

.styles_box__oaQFc {
    width: var(--item-size, 70px);
    height: var(--item-size, 70px);
    display: flex;
    justify-content: center;
    align-items: center;
    /*background: #fff;*/
    position: relative;
}

.styles_boxInner__oJ4yz {
    --icon-stroke: 1;
    --icon-color-custom: var(--light-grey);
    border: 1px dashed var(--light-grey);
    padding: 8px;
    width: var(--item-size, 70px);
    height: var(--item-size, 70px);
    background: #fff;
    position: relative;
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
}

.styles_row__z31sT {
    display: flex;
    justify-content: space-between;
}

.styles_arrow__Wwp\\+K {
    position: absolute;
    top: var(--item-size, 80px);
    left: 0;
    right: 0;
    margin: auto;
    width: 20px;
    display: flex;
    justify-content: center;
    height: calc(100% - var(--item-size, 70px) - 30px);
}

.styles_arrow__Wwp\\+K:before {
    content: '';
    background: var(--light-grey);
    display: block;
    width: 1px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.styles_arrow__Wwp\\+K:after {
    content: '';
    display: block;
    position: absolute;
    top: 100%;
    z-index: 1;
    width: 0;
    height: 0;
    left: 0;
    right: 0;
    margin: auto;

    border-left: 6px solid transparent;
    border-right: 6px solid transparent;

    border-top: 10px solid var(--light-grey);
}

.styles_item__VyTt4:nth-child(2) .styles_arrow__Wwp\\+K {
    height: calc(100% - 18px);
}

.styles_item__VyTt4:not(.styles_horizontal__\\+scOI) .styles_arrow__Wwp\\+K {
    height: 30px;
    /*top: calc(100% - var(--item-size, 70px) - 30px);*/
}

/*.arrow {*/
/*    top: 186px;*/
/*}*/

/*.arrow {*/
/*    height: 90px;*/
/*}*/

/*.item:not(.horizontal) .arrow {*/
/*    height: 45px;*/
/*}*/
/*.arrow {*/
/*    top: 134px;*/
/*}*/

.styles_item__VyTt4:not(.styles_horizontal__\\+scOI):first-child .styles_arrow__Wwp\\+K {
    transform: rotate(-60deg) translateX(70px) translateY(50px);
}

.styles_item__VyTt4:not(.styles_horizontal__\\+scOI):last-child .styles_arrow__Wwp\\+K {
    transform: rotate(60deg) translateX(-70px) translateY(50px);
}

/*.active {*/
/*    color: var(--primary-color);*/
/*}*/

.styles_active__2kVps .styles_boxInner__oJ4yz {
    border-color: var(--primary-color);
    border-style: solid;
    --icon-color-custom: var(--primary-color);
}

.styles_active__2kVps .styles_arrow__Wwp\\+K:after,
.styles_active__2kVps .styles_arrow__Wwp\\+K:before {
    border-top-color: var(--primary-color);
}

.styles_active__2kVps .styles_arrow__Wwp\\+K:before {
    background-color: var(--primary-color);
}

.styles_multiple__mOJVL {
    position: relative;
    margin-top: 8px;
    /*left: 8px;*/
    width: calc(var(--item-size, 70px) + 8px);
    height: calc(var(--item-size, 70px) + 8px);
}

.styles_multiple__mOJVL:before,
.styles_multiple__mOJVL:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid var(--primary-color);
    width: var(--item-size, 70px);
    height: var(--item-size, 70px);
    z-index: 2;
    background: #fff;
}

.styles_multiple__mOJVL:after {
    top: -4px;
    left: -4px;
    z-index: 1;
}

.styles_other__coVsS {
    margin: -40px 0 0 80%;
    padding: 0;
}

.styles_other__coVsS.styles_item__VyTt4 {
    --item-size: 50px;
}

.styles_other__coVsS.styles_item__VyTt4 h6 {
    top: -20px;
}

@media (max-height: 760px) {
    .styles_item__VyTt4.styles_horizontal__\\+scOI:nth-child(2) {
        flex: unset;
    }
}

@media (min-height: 1080px) {
    .styles_header__Q0alu {
        margin-bottom: 80px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_item__VyTt4:not(.styles_horizontal__\\+scOI):first-child .styles_arrow__Wwp\\+K {
        transform: rotate(-60deg) translateX(60px) translateY(30px);
    }

    .styles_item__VyTt4:not(.styles_horizontal__\\+scOI):last-child .styles_arrow__Wwp\\+K {
        transform: rotate(60deg) translateX(-60px) translateY(30px);
    }

    .styles_item__VyTt4 .styles_boxInner__oJ4yz svg {
        width: 25px;
        height: 25px;
    }

    .styles_item__VyTt4 h6 {
        font-size: 13px;
    }

    .styles_item__VyTt4:not(.styles_horizontal__\\+scOI):not(.styles_other__coVsS) h6 {
        top: -36px;
    }

    .styles_boxInner__oJ4yz,
    .styles_multiple__mOJVL:before,
    .styles_multiple__mOJVL:after {
        --icon-stroke: 0.75px;
        border-width: 0.75px;
    }

    .styles_arrow__Wwp\\+K:before {
        transform: scaleX(0.75);
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_item__VyTt4 h6 {
        font-size: 16px;
        max-width: 160px;
    }

    .styles_item__VyTt4 {
        --item-size: 100px;
    }

    .styles_item__VyTt4.styles_other__coVsS {
        --item-size: 75px;
    }

    .styles_info__s7R1j p {
        font-size: 16px;
    }

    .styles_boxInner__oJ4yz span svg {
        width: 50px;
        height: 50px;
    }

    .styles_row__z31sT {
        padding: 0 34px;
    }

    .styles_row__z31sT .styles_item__VyTt4:first-child:not(.styles_horizontal__\\+scOI) h6 {
        top: -20px;
    }

    .styles_item__VyTt4:not(.styles_horizontal__\\+scOI) h6 {
        top: -20px;
        width: calc(100% + 60px);
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/StorageForm/components/StorageCurrentStatus/styles.module.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,oCAAoC;IACpC,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;;IAEZ,kCAAkC;IAClC,mCAAmC;;IAEnC,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mDAAmD;AACvD;;AAEA,WAAW;AACX,kBAAkB;AAClB,IAAI;;AAEJ,WAAW;AACX,oBAAoB;AACpB,IAAI;;AAEJ,kCAAkC;AAClC,oBAAoB;AACpB,IAAI;AACJ,WAAW;AACX,kBAAkB;AAClB,IAAI;;AAEJ;IACI,2DAA2D;AAC/D;;AAEA;IACI,2DAA2D;AAC/D;;AAEA,YAAY;AACZ,mCAAmC;AACnC,IAAI;;AAEJ;IACI,kCAAkC;IAClC,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,yCAAyC;IACzC,0CAA0C;AAC9C;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,sCAAsC;IACtC,6BAA6B;IAC7B,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2DAA2D;IAC/D;;IAEA;QACI,2DAA2D;IAC/D;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;;;QAGI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,wBAAwB;QACxB,kBAAkB;IACtB;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max from '../../../../../breakpoints.css';\n\n.content {\n    margin: 0 0;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n}\n\n.header h3 {\n    margin: auto 0;\n}\n\n@media (min-height: 1080px) {\n    .content {\n        min-height: 750px;\n    }\n}\n\n.footer {\n    text-align: center;\n    border-top: 1px solid var(--light-grey);\n    padding-top: 35px;\n}\n\n.item {\n    display: flex;\n    grid-gap: 12px;\n    padding-bottom: 16px;\n    position: relative;\n}\n\n.item.horizontal {\n    flex: 1;\n    max-width: 100%;\n    min-height: 80px;\n    justify-content: center;\n    padding: 0 14px;\n}\n\n.item:not(.horizontal) {\n    flex-direction: column;\n    align-items: center;\n}\n\n.item h6 {\n    font-weight: 100;\n    text-transform: none;\n    font-size: 14px;\n    max-width: 100px;\n    position: absolute;\n}\n\n.item.horizontal h6 {\n    left: calc(50% + calc(var(--item-size, 70px)) / 2 + 10px);\n}\n\n.box {\n    width: var(--item-size, 70px);\n    height: var(--item-size, 70px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /*background: #fff;*/\n    position: relative;\n}\n\n.boxInner {\n    --icon-stroke: 1;\n    --icon-color-custom: var(--light-grey);\n    border: 1px dashed var(--light-grey);\n    padding: 8px;\n    width: var(--item-size, 70px);\n    height: var(--item-size, 70px);\n    background: #fff;\n    position: relative;\n    z-index: 4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.arrow {\n    position: absolute;\n    top: var(--item-size, 80px);\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 20px;\n    display: flex;\n    justify-content: center;\n    height: calc(100% - var(--item-size, 70px) - 30px);\n}\n\n.arrow:before {\n    content: '';\n    background: var(--light-grey);\n    display: block;\n    width: 1px;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.arrow:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 100%;\n    z-index: 1;\n    width: 0;\n    height: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n\n    border-top: 10px solid var(--light-grey);\n}\n\n.item:nth-child(2) .arrow {\n    height: calc(100% - 18px);\n}\n\n.item:not(.horizontal) .arrow {\n    height: 30px;\n    /*top: calc(100% - var(--item-size, 70px) - 30px);*/\n}\n\n/*.arrow {*/\n/*    top: 186px;*/\n/*}*/\n\n/*.arrow {*/\n/*    height: 90px;*/\n/*}*/\n\n/*.item:not(.horizontal) .arrow {*/\n/*    height: 45px;*/\n/*}*/\n/*.arrow {*/\n/*    top: 134px;*/\n/*}*/\n\n.item:not(.horizontal):first-child .arrow {\n    transform: rotate(-60deg) translateX(70px) translateY(50px);\n}\n\n.item:not(.horizontal):last-child .arrow {\n    transform: rotate(60deg) translateX(-70px) translateY(50px);\n}\n\n/*.active {*/\n/*    color: var(--primary-color);*/\n/*}*/\n\n.active .boxInner {\n    border-color: var(--primary-color);\n    border-style: solid;\n    --icon-color-custom: var(--primary-color);\n}\n\n.active .arrow:after,\n.active .arrow:before {\n    border-top-color: var(--primary-color);\n}\n\n.active .arrow:before {\n    background-color: var(--primary-color);\n}\n\n.multiple {\n    position: relative;\n    margin-top: 8px;\n    /*left: 8px;*/\n    width: calc(var(--item-size, 70px) + 8px);\n    height: calc(var(--item-size, 70px) + 8px);\n}\n\n.multiple:before,\n.multiple:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: 1px solid var(--primary-color);\n    width: var(--item-size, 70px);\n    height: var(--item-size, 70px);\n    z-index: 2;\n    background: #fff;\n}\n\n.multiple:after {\n    top: -4px;\n    left: -4px;\n    z-index: 1;\n}\n\n.other {\n    margin: -40px 0 0 80%;\n    padding: 0;\n}\n\n.other.item {\n    --item-size: 50px;\n}\n\n.other.item h6 {\n    top: -20px;\n}\n\n@media (max-height: 760px) {\n    .item.horizontal:nth-child(2) {\n        flex: unset;\n    }\n}\n\n@media (min-height: 1080px) {\n    .header {\n        margin-bottom: 80px;\n    }\n}\n\n@media screen-md-max {\n    .item:not(.horizontal):first-child .arrow {\n        transform: rotate(-60deg) translateX(60px) translateY(30px);\n    }\n\n    .item:not(.horizontal):last-child .arrow {\n        transform: rotate(60deg) translateX(-60px) translateY(30px);\n    }\n\n    .item .boxInner svg {\n        width: 25px;\n        height: 25px;\n    }\n\n    .item h6 {\n        font-size: 13px;\n    }\n\n    .item:not(.horizontal):not(.other) h6 {\n        top: -36px;\n    }\n\n    .boxInner,\n    .multiple:before,\n    .multiple:after {\n        --icon-stroke: 0.75px;\n        border-width: 0.75px;\n    }\n\n    .arrow:before {\n        transform: scaleX(0.75);\n    }\n}\n\n@media screen-lg-min {\n    .item h6 {\n        font-size: 16px;\n        max-width: 160px;\n    }\n\n    .item {\n        --item-size: 100px;\n    }\n\n    .item.other {\n        --item-size: 75px;\n    }\n\n    .info p {\n        font-size: 16px;\n    }\n\n    .boxInner span svg {\n        width: 50px;\n        height: 50px;\n    }\n\n    .row {\n        padding: 0 34px;\n    }\n\n    .row .item:first-child:not(.horizontal) h6 {\n        top: -20px;\n    }\n\n    .item:not(.horizontal) h6 {\n        top: -20px;\n        width: calc(100% + 60px);\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"content": `styles_content__9juYu`,
	"header": `styles_header__Q0alu`,
	"footer": `styles_footer__Wv3M1`,
	"item": `styles_item__VyTt4`,
	"horizontal": `styles_horizontal__+scOI`,
	"box": `styles_box__oaQFc`,
	"boxInner": `styles_boxInner__oJ4yz`,
	"row": `styles_row__z31sT`,
	"arrow": `styles_arrow__Wwp+K`,
	"active": `styles_active__2kVps`,
	"multiple": `styles_multiple__mOJVL`,
	"other": `styles_other__coVsS`,
	"info": `styles_info__s7R1j`
};
export default ___CSS_LOADER_EXPORT___;
